<template>
  <div class="usersComp">

    <label v-show="eventId ? infoMessageEvent : ''" class="label_info">{{ infoMessageEvent }}</label>
    <label v-show="groupId ? infoMessageGroup : ''" class="label_info">{{ infoMessageGroup }}</label>
    <users-filters-comp v-show="showFilters" :showSliders="showFilters"/>
    <tbl-comp
      v-show="!showFilters"
      :model="this.$store.getters[`${this.moduleName}/getModel`]"
      :paging="true"
      :rowClick="rowClick"
      :moduleName="moduleName"
      :params="onFilter ? Object.assign(filters, params, {eventId}, {groupId}) : Object.assign(params, {eventId}, {groupId})"
      :searchInput="true"
      :filters="onFilter"
      :searchPlaceholder="'Номер телефона'"
      :checkboxClick="checkboxClick"
      :searchMask="$helpers.input.masks.phone"
    />

  </div>
</template>

<script>
import httpService from '../http'
import api from '../api'

export default {
  name: 'usersComp',
  props: {
    params: { type: Object, default: () => {} },
    onFilter: { type: Boolean, default: () => false },
    required: {
      type: Array,
      default: () => [
        'id',
        'phone',
        'repost',
        'bonus',
        'sale',
        'bonusDate',
        'group',
        'ordersCount',
        'ordersBonus',
        'ordersPrice'
      ] },
    eventId: { type: Number, default: () => 0 },
    groupId: { type: Number, default: () => 0 }
  },
  data: function () {
    return {
      show: false,
      moduleName: 'users',
      orders: {
        moduleName: 'orders'
      },
      usersCountEvent: 0,
      usersCountGroup: 0
    }
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getFilters`, {})
    this.$store.dispatch(`${this.moduleName}/setModelRequired`, { required: this.required })
    this.getCountEvent()
    this.getCountGroup()
  },
  components: {
  },
  computed: {
    filters: function () {
      return this.$store.getters[`${this.moduleName}/getFiltersQuery`]
    },
    showFilters: function () {
      return this.$store.getters[`${this.moduleName}/getShowFilters`]
    },
    role: function () {
      return localStorage.getItem('role')
    },
    infoMessageEvent: function () {
      let c = this.usersCountEvent
      let s = 'все'
      if (c > 0) s = c
      return `Участвуют в акции: ${s}`
    },
    infoMessageGroup: function () {
      return `Состоит в группе: ${this.usersCountGroup}`
    }
  },
  methods: {
    add () {
      this.$store.dispatch(`${this.moduleName}/toAdd`)
    },
    rowClick (row) {
      this.$store.dispatch(`${this.moduleName}/toUpdate`, { id: row.id })
    },
    checkboxClick (row, col, checked) {
      if (col.data === 'userEvents') {
        let data = {
          userId: row.id,
          eventId: this.eventId,
          add: checked
        }
        this.setUserToEvent(data)
      } else if (col.data === 'group') {
        let data = {
          userId: row.id,
          groupId: this.groupId,
          add: checked
        }
        this.setUserToGroup(data)
      }
    },
    async setUserToEvent (data) {
      try {
        let result = await httpService.post(api.events[this.role].setUser, data)
        let count = result.data.count
        this.usersCountEvent = count.users
      } catch (err) {
        console.log(err)
      }
    },
    async setUserToGroup (data) {
      try {
        let result = await httpService.post(api.groups[this.role].setUser, data)
        let count = result.data.count
        this.usersCountGroup = count
      } catch (err) {
        console.log(err)
      }
    },
    async getCountEvent () {
      try {
        let count = await httpService.get(api.events[this.role].count, { eventId: this.eventId })
        count = count.data.count
        this.usersCountEvent = count.users
      } catch (err) {
        console.log(err)
      }
    },
    async getCountGroup () {
      try {
        let count = await httpService.get(api.groups[this.role].getUserCount, { groupId: this.groupId })
        count = count.data.count
        this.usersCountGroup = count
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped lang="scss">

.label_info {
  float: right;
  margin: 5px 32px 5px auto;
}

</style>
